import * as React from 'react';
import { formatPointsByLocale } from 'lowcomp/plugins/member/utils';
import { TranslationFn } from '../types';

interface PointsDisplayProps {
    isLogin: boolean;
    points: number | undefined;
    locale: string;
    t: TranslationFn;
}

/**
 * PointsDisplay - Component for displaying user's points
 */
const PointsDisplay: React.FC<PointsDisplayProps> = ({ isLogin, points, locale, t }) => {
    if (!isLogin) return null;

    return (
        <div className="credits-desc-container">
            <span className="credits-desc">
                {t.rich('have_points', {
                    code: (children?: string) => <i className="points">{children}</i>,
                    points: formatPointsByLocale(points, locale) || '0',
                })}
            </span>
        </div>
    );
};

export default PointsDisplay;
